import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AutoRoutingResultsComponent } from './auto-routing-results.component';

const routes: Routes = [
  {  path: 'autorouting/:id',
    component: AutoRoutingResultsComponent,
    data: {
      title: 'Auto routing'
    }}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AutoRoutingResultsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/auto-routing-results/auto-routing-results-routing.module.ts